import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import {IController, IFormController, IModule, IOnChangesObject, IQService, IScope} from "angular";
import {l} from "types/typescriptdefinisjoner_lederplan";
import {BrukerRessurs} from "felles/tjenester/ressurser/BrukerRessurs";
import {WebNavigasjon} from "../../../../tjenester/WebNavigasjon";
import {gettextCatalog} from "angular-gettext";
import {dersomChangesInneholder} from "felles/stoettefunk/angularHjelpemetoder";
import {Kontekst} from "felles/tjenester/Kontekst";
import {MeldingTilBruker} from "felles/tjenester/MeldingTilBruker";


const css = require('./meldingsinnstillinger.scss');

export class MeldingsinnstillingerKontroller implements IController {

    static registrerKomponent(angular: IModule) {
        angular
          .component('wmBrukerMeldingsinnstillinger', {
              bindings: {
                  bruker: '<'
              },
              controller: MeldingsinnstillingerKontroller.forInjisering(),
              template: require('./meldingsinnstillinger.html')
          });
    }

    static forInjisering() {
        return [
            regNavn.ng.$scope,
            regNavn.ng.$q,
            BrukerRessurs.regNavn,
            WebNavigasjon.regNavn,
            Kontekst.regNavn,
            MeldingTilBruker.regNavn,
            regNavn.gettext.gettextCatalog,
            MeldingsinnstillingerKontroller
        ]
    }

    constructor(private $scope: IScope,
                private $q: IQService,
                private brukerRes: BrukerRessurs,
                private webNavigasjon:WebNavigasjon,
                private kontekst:Kontekst,
                private meldingTilBruker:MeldingTilBruker,
                private gettextCatalog:gettextCatalog) {
    }

    bruker: l.BrukerModell; //settes via bindings/$onChanges

    modell:Skjemamodell;

    lagre(skjema: IFormController){
        this.brukerRes.oppdaterMeldingsinnstillinger(this.bruker.id, this.modell.somSpesifikasjon()).$promise
            .then(bruker=> {
                this.kontekst.oppdaterAutentisertBruker(bruker);
                this.initBruker(bruker);
                this.meldingTilBruker.infomelding(this.gettextCatalog.getString('Dine meldingsinnstillinger har blitt oppdatert'));
            });
    }

    $onChanges(changes: IOnChangesObject) {
        dersomChangesInneholder(changes, 'bruker', bruker => this.initBruker(bruker));
    }

    private initBruker(bruker:l.BrukerModell){
        this.bruker = bruker
        this.modell = new Skjemamodell(bruker);
    }

}

class Skjemamodell {

    constructor(bruker:l.BrukerModell) {
        this.forfalteOppgaverAktivert = !bruker.deaktiverteMeldingstyper.includes(l.DeaktivertMeldingstype.forfalteOppgaver);
        this.sakTildeltAktivert = !bruker.deaktiverteMeldingstyper.includes(l.DeaktivertMeldingstype.sakTildelt);
        this.oppgaveTildeltAktivert = !bruker.deaktiverteMeldingstyper.includes(l.DeaktivertMeldingstype.oppgaveTildelt);
    }

    forfalteOppgaverAktivert:boolean;
    sakTildeltAktivert:boolean;
    oppgaveTildeltAktivert:boolean;

    somSpesifikasjon():l.MeldingsinnstillingerSpesifikasjon{
        const deaktiverte:l.DeaktivertMeldingstype[] = [];
        if (!this.forfalteOppgaverAktivert) deaktiverte.push(l.DeaktivertMeldingstype.forfalteOppgaver);
        if (!this.sakTildeltAktivert) deaktiverte.push(l.DeaktivertMeldingstype.sakTildelt);
        if (!this.oppgaveTildeltAktivert) deaktiverte.push(l.DeaktivertMeldingstype.oppgaveTildelt);
        return {deaktiverteMeldingstyper:deaktiverte};
    }
}
